import ItemType from "../../../../../enums/itemType.enum";
import { IProfile } from "../../../../../models/profile.model";
import ItemCard from "../../../item-spawner-page/components/item-card/ItemCard";
import "./ProfileCard.scss";

interface IProfileCardProps {
  profile: IProfile;
  children?: any;
}

const ProfileCard = (props: IProfileCardProps) => {
  const weapons = props.profile.items.filter((i) => i.type === ItemType.Weapon);
  const magazines = props.profile.items.filter(
    (i) => i.type === ItemType.Magazine
  );
  const backpacks = props.profile.items.filter(
    (i) => i.type === ItemType.Backpack
  );

  return (
    <div className="profile-card">
      <div className="title-bar">
        <div className="title">
          <i className="fa-solid fa-boxes-stacked"></i> {props.profile.name}
        </div>
        {props.children && (
          <div className="actions">
            {props.children}
          </div>
        )}
      </div>
      <div className="card-content">
        {weapons.map((w, i) => {
          return (
            <ItemCard
              classname={w.classname}
              amount={w.amount}
              itemType={ItemType.Weapon}
              key={i}
            />
          );
        })}
        {magazines.map((m, i) => {
          return (
            <ItemCard
              classname={m.classname}
              amount={m.amount}
              itemType={ItemType.Magazine}
              key={i}
            />
          );
        })}
        {backpacks.map((b, i) => {
          return (
            <ItemCard
              classname={b.classname}
              amount={b.amount}
              itemType={ItemType.Backpack}
              key={i}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProfileCard;
